import script from './form-item.vue_vue_type_script_lang.mjs';
export { default } from './form-item.vue_vue_type_script_lang.mjs';
import { render } from './form-item.vue_vue_type_template_id_24eda48b_lang.mjs';

script.render = render;
script.__file = "packages/components/form/src/form-item.vue";
//# sourceMappingURL=form-item.mjs.map
